<template>
  <div class="content">
    <div class="container-fluid">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
      <p class="text-right small">
          v{{ version }}
        </p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      version: process.env.VUE_APP_VERSION
    };
  }
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}

.fade-enter,
  .fade-leave-to
  /* .fade-leave-active in <2.1.8 */

 {
  opacity: 0;
}
</style>
